import { TChartDataApiResponse, TChartData } from '../../../types';

/**
 * Проверяет поле priceHistoryChartData в ответе API на наличие ключей.
 * Если ключи есть - это будет означать, что данные для графика есть
 * */
export const hasChartData = (priceHistoryChartData: TChartDataApiResponse): priceHistoryChartData is TChartData => {
  return Boolean(
    priceHistoryChartData && typeof priceHistoryChartData === 'object' && Object.keys(priceHistoryChartData).length,
  );
};
